/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const challengeRateLimitDataSchema = z.object({
  limited: z.boolean(),
  used: z.number().int(),
  limit: z.number().int(),
  resetsAt: z.number().int().nullable(),
  windowHours: z.number(),
});

export type IChallengeRateLimitData = z.infer<typeof challengeRateLimitDataSchema>;

export const getChallengeRateLimitResponseSchema = createApiResponseSchema(
  challengeRateLimitDataSchema,
) as z.ZodSchema<IAPI<IChallengeRateLimitData>>;

export type IGetChallengeRateLimitResponse = IAPI<IChallengeRateLimitData>;
